export const PERIODS_TITLE = {
    BOY: 'Beginning',
    MOY: 'Middle',
    EOY: 'End',
};

export const ASSESSMENT_STATUS = {
    STUDENTS_ASSESSED: 'Students Assessed',
    STUDENTS_NOT_ASSESSED: 'Not Assessed',
    IN_PROGRESS: 'In Progress',
};

export const FR_SUMMARY_VIEW = {
    summarySectionClass: 'class-summary-section mr-1',
    subHeaderClass: 'sub-header',
    showTotalStudentsCount: false,
    status: [
        ASSESSMENT_STATUS.STUDENTS_ASSESSED,
        ASSESSMENT_STATUS.STUDENTS_NOT_ASSESSED,
        ASSESSMENT_STATUS.IN_PROGRESS,
    ],
};
